import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted } from "vue"
import BeginApplication from "@/components/apply/BeginApplication.vue"
import ApplicationFlow from "@/components/apply/ApplicationFlow.vue"
import { APPLICATION_TRACK_LS_KEY } from "@/components/apply/shared/constants"
import { useQuery } from "@vue/apollo-composable"
import { ApplicationTrackQuery, ApplicationTrackQueryQuery, ApplicationTrack } from "@/gql"
import useRouter from "@/router/useRouter"
import EventBus from "@/components/EventBus"


export default /*#__PURE__*/_defineComponent({
  __name: 'Apply',
  setup(__props) {

const hasApplication = ref(false)
const applicationTrack = ref<ApplicationTrack | null>(null)

const { router } = useRouter()
const id = router.currentRoute.params.id

const onProceedToApplicationFlow = () => {
  startApplication()
}

const { loading, onResult } = useQuery<ApplicationTrackQueryQuery>(ApplicationTrackQuery, {
  id,
})

onResult((result) => {
  if (result.data?.applicationTrack) {
    applicationTrack.value = result.data.applicationTrack as ApplicationTrack
  }
})

const startApplication = () => {
  hasApplication.value = true

  localStorage.setItem(
    APPLICATION_TRACK_LS_KEY,
    JSON.stringify({
      id,
      hasApplication: true,
    })
  )
}

onMounted(() => {
  const applicationTrackDetails = localStorage.getItem(APPLICATION_TRACK_LS_KEY)
    ? JSON.parse(localStorage.getItem(APPLICATION_TRACK_LS_KEY) as string)
    : null

  if (applicationTrackDetails) hasApplication.value = true

  EventBus.$on("logout", () => {
    hasApplication.value = false
  })
})

return { __sfc: true,hasApplication, applicationTrack, router, id, onProceedToApplicationFlow, loading, onResult, startApplication, BeginApplication, ApplicationFlow }
}

})